import React, { useState } from 'react';
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash, faToggleOn, faToggleOff } from "@fortawesome/free-solid-svg-icons";
import "./acoesAnuncio.css";
import { putDesativarAnuncio } from '../../services/apiAnuncio';

interface AcoesAnuncioProps {
  cdAnuncio: any;
  dmAtivo: boolean;
  dtPublicacao: any;
}

const AcoesAnuncio: React.FC<AcoesAnuncioProps> = ({ cdAnuncio, dmAtivo, dtPublicacao }) => {
  const [isActive, setIsActive] = useState(dmAtivo);
  const dataAtual = new Date();
  const handleToggle = async () => {
    const cdUsuario = localStorage.getItem('cdUsuario')
    try {
      await putDesativarAnuncio({ cdAnuncio, dmAtivo: !isActive, cdUsuarioAlt: cdUsuario });
      setIsActive(!isActive);
      window.location.reload();
    } catch (error) {
      console.error("Erro ao desativar/ativar anúncio:", error);
    }
  };

  const dtPublicacaoDate = new Date(dtPublicacao);

  return (
    <div className='botoesAcoes'>
      <div className='iconeAlterar' title="Alterar">
        <Link to={`/milshop/anuncio/alterar/${cdAnuncio}`}>
          <FontAwesomeIcon
            icon={faPen}
            style={{ color: "var(--azul-escuro)" }}
            size="2x"
          />
        </Link>
      </div>
      {dtPublicacaoDate <= dataAtual && (
        <div
          className='iconeDesativar'
          title={isActive ? "Desativar" : "Ativar"}
          onClick={handleToggle}
          style={{ cursor: 'pointer' }}>
          <FontAwesomeIcon
            icon={isActive ? faToggleOn : faToggleOff}
            size="2x"
          />
          <span>{isActive ? "Ativo" : "Desativado"}</span>
        </div>
      )}
      <div className='iconeExcluir' title="Excluir">
        <Link to={`/milshop/anuncio/excluir/${cdAnuncio}`}>
          <FontAwesomeIcon
            icon={faTrash}
            style={{ color: "var(--danger)" }}
            size="2x"
          />
        </Link>
      </div>
    </div>
  );
};

export default AcoesAnuncio;